import React from 'react';
import { BalancesCard } from './BalancesCard';
import { Spinner } from 'ui-toolkit';
import { useGetEscrowBalancesDataQuery } from '../../../../API/order/escrow/EscrowBaseAPI';

interface IBalancesContainerProps {
  orderId: string;
}

export const BalancesContainer: React.FC<IBalancesContainerProps> = ({ orderId }) => {
  const { data: balances, isLoading, isSuccess } = useGetEscrowBalancesDataQuery(orderId);

  return (
    <>
      {isLoading && <Spinner />}
      {isSuccess && balances && (
        <BalancesCard
          actual={balances.actualAmountDollars}
          available={balances.availableAmountDollars}
          totalDeposits={balances.depositsTotalAmountDollars}
          totalDisbursements={balances.disbursementsTotalAmountDollars}
        />
      )}
    </>
  );
};
